import React from "react";

/**
 * Logo component
 * Default size (in navbar) is 152px = 4x the previous 38px.
 * The image itself contains the "THE FOOD GALA — THE BEST IN TOWN" wordmark,
 * so we keep the optional text wordmark compact and single-line beside it.
 */
export default function Logo({ size = 152, withWordmark = true, dark = false, compact = false }) {
    const showWordmark = withWordmark && !compact;
    return (
        <div className="flex items-center gap-3" data-testid="brand-logo">
            <img
                src="/brochure/foodgala_logo.jpg"
                alt="The Food Gala — The Best in Town"
                style={{ width: size, height: size, objectFit: "contain" }}
                className="block select-none"
                draggable={false}
            />
            {showWordmark && (
                <div className="leading-none whitespace-nowrap">
                    <div
                        className={`font-display tracking-tight font-bold text-[1.5rem] md:text-[1.85rem] ${
                            dark ? "text-[#FAF9F6]" : "text-[#1A1A1A]"
                        }`}
                    >
                        The Food Gala
                    </div>
                    <div
                        className={`mt-1 text-[10px] md:text-[11px] uppercase tracking-[0.32em] font-semibold ${
                            dark ? "text-[#FAF9F6]/70" : "text-[#1B4332]/70"
                        }`}
                    >
                        The Best in Town
                    </div>
                </div>
            )}
        </div>
    );
}
